import { useCallback } from 'react';
import * as Yup from 'yup';
import { validarCNPJ, validarCPF, validarCPFCNPJ } from 'utils/cpfcnpj-validate';

export const useValidationYupDocumento = (nullable: boolean) => {
    const documentoYup = useCallback((type?: 'CPF' | 'CNPJ') => {
        if (nullable) {
            return (Yup.string()
                .test('cnpj', 'O CNPJ está inválido.',
                    (value) => {
                        if (type === 'CNPJ') {
                            const valueString = value as string
                            if (valueString !== undefined && valueString.length > 0) {
                                if (valueString.length >= 15) {
                                    return validarCNPJ(valueString)
                                }
                            }
                        }
                        return true
                    })
                .test('cpf', 'O CPF está inválido', (value) => {
                    if (type === 'CPF') {
                        const valueString = value as string
                        if (valueString !== undefined && valueString.length > 0) {
                            if (valueString.length < 15) {
                                return validarCPF(valueString)
                            }
                        }
                    }
                    return true
                }).test('documento', 'Documento inválido', (value) => {
                    let isValid = true
                    if (value !== undefined && value.length > 0) {
                        isValid = validarCPFCNPJ(value as string)
                    }
                    return isValid
                })
            )
        } else {
            return (Yup.string().required(`O ${type !== undefined ? type : 'documento'} é obrigatório.`)
                .test('cnpj', 'O CNPJ está inválido.',
                    (value) => {
                        if (type === 'CNPJ') {
                            const valueString = value as string
                            if (valueString !== undefined) {
                                if (valueString.length >= 15) {
                                    return validarCNPJ(valueString)
                                }
                            }
                        }
                        return true
                    })
                .test('cpf', 'O CPF está inválido', (value) => {
                    if (type === 'CPF') {
                        const valueString = value as string
                        if (valueString !== undefined) {
                            if (valueString.length < 15) {
                                return validarCPF(valueString)
                            }
                        }
                    }
                    return true
                }).test('documento', 'Documento inválido', (value) => {
                    let isValid = false
                    if (value !== undefined) {
                        isValid = validarCPFCNPJ(value as string)
                    }
                    return isValid
                })
            )
        }
    }, [nullable])
    return {
        documentoYup,
    }
}
